import { useRef, useEffect } from 'react';
import { DownOutlined } from '@ant-design/icons';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';

export const useServerSideSelectFilter = (
  dataIndex,
  filters,
  setFilters,
  options, // string[]
) => {
  const selectRef = useRef(null);
  const { t } = useTranslation();

  return {
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      visible,
    }) => {
      useEffect(() => {
        if (visible && selectRef.current) {
          setTimeout(() => selectRef.current?.focus(), 100);
        }

        // Sync selectedKeys with filters on visibility change
        if (visible) {
          const current = filters[dataIndex];
          setSelectedKeys(Array.isArray(current) ? current : []);
        }
      }, [visible]);

      return (
        <div style={{ padding: 8 }}>
          <Select
            ref={selectRef}
            mode="multiple"
            allowClear
            showSearch
            placeholder={t('Vybrať filter')}
            style={{ width: 250 }}
            value={selectedKeys}
            onChange={(values) => {
              setSelectedKeys(values);
              const newFilters = { ...filters };
              if (values.length > 0) {
                newFilters[dataIndex] = values;
              } else {
                delete newFilters[dataIndex];
              }
              setFilters(newFilters);
              confirm({ closeDropdown: true });
            }}
            options={options.map((val) => ({ value: val, label: val }))}
          />
        </div>
      );
    },
    filterIcon: (filtered) => (
      <DownOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    filteredValue: filters[dataIndex] ?? null,
    onFilterClear: () => {
      const updated = { ...filters };
      delete updated[dataIndex];
      setFilters(updated);
    },
  };
};
